<template>
	<div class="result-wrapper height-100 pb-12">
		<div v-if="loaded" class="height-100 pb-12">

			<div class="card-body">
				<h2 class="result-title">
				<span v-if="results">
					Результат теста: <br> {{data.testing.title}}
				</span>

					<span v-else>Тест пройден!<br> Обрабатываем результаты...</span>
				</h2>
				<div class="result-bottom">
					<span class="result-bottom-item">Дата прохождения: <span>{{ moment(data.passed_at).format('DD.MM.YYYY') }}</span></span>
					<span class="result-bottom-item">Время прохождения: <time>{{ data.time_range }}</time></span>
				</div>

				<!-- Charts -->
				<div v-if="results">
					<h2 class="h2-title">{{data.testing.chart.label}}</h2>
					<LinearChart v-if="data.testing.chart.type === 'linear'" :data="data.sequences"/>
					<BipolarChart v-else :data="data.sequences"/>
				</div>

				<div v-else class="without-results">
					<div class="without-results-col md-w-7 ">
						<div class="without-results-left height-100">
							<h3 class="without-results-left-title">Результаты появятся на этой странице автоматически после
								проверки ответов</h3>
							<p class="without-results-left-subtitle">Обычно проверка занимает до 10 минут</p>
						</div>
					</div>
					<div class="without-results-col md-w-5 ">
						<div class="without-results-right height-100">
							<h3 class="without-results-right-title">Так же результаты будут в личном кабинете сайта:</h3>
							<a href="https://bolshayaperemena.online/cabinet" target="_blank" class="without-results-right-link">«Большая перемена»</a>
						</div>
					</div>
				</div>

			</div>

			<!-- Test modules -->
			<div v-if="results">
				<div v-if="data.testing.is_final">
					<Choice @openModal="openModal"/>
					<BannerSuits :data="data.current_challenge"/>
					<ResultModal v-if="showModal" :token="token" :show-modal="showModal" @close="showModal = false" @update="update"/>
				</div>


				<BannerGoodJob v-if="data.testing.good_job.show" :title="data.testing.good_job.label" :description="data.testing.good_job.text"/>

				<section v-if="data.comments.length">
					<Recommendations class="card-body" :comment="data.comments_pronounced" :data="data.comments"/>
				</section>

				<section v-if="data.descriptions">
					<CallDescription v-if="data.testing.is_final" :data="data.descriptions"/>

					<ResultDescription v-else class="card-body" :data="data.descriptions"/>
				</section>

				<BannerCongratulations v-if="data.testing.congratulations.show" :title="data.testing.congratulations.label" :description="data.testing.congratulations.text"/>
			</div>

		</div>

		<!-- Loading -->
		<div v-else class="loader-wrapper">
			<div class="loader-container">
				<div class="loader top-20 left-30 right-0"></div>
			</div>
			<div class="loader-description">
				Ищем твои результаты...
			</div>
		</div>
	</div>
</template>

<style lang="css">
	/*Global */
	:root {
		--main: #FFE074;
		--accent-1: #282C58;
		--accent-1-light: #52578A;
		--accent-2: #FF7271;
		--background-1: #EDEEF0;
		--background-3: #EFEFFF;
		--black-20: #D0D0D3;
		--black-40: #9A9BA0;
		--black-60: #6D6D73;
		--black-80: #404044;
		--black-90: #262629;
		--success: #48A467;
	}
	*, ::before, ::after {
		box-sizing: border-box;
	}
	body {
		background-color: var(--background-1);
	}
	.btn-unstyled:focus {
		outline: none;
	}
	.btn-default {
		cursor: pointer;
		border: none;
		background-color: var(--accent-1);
		padding: 8px 33px;
		font-size: 14px;
		color: #fff;
		font-family: "Galiver Sans", sans-serif;
	}
	.link-underscore {
		text-decoration: none;
		font-weight: bold;
		font-size: 14px;
		line-height: 18px;
		color: var(--accent-1-light);
		border-bottom: 1px solid var(--accent-1-light);
		display: inline-block;
	}
	.result-wrapper {
		position: relative;
		font-family: Open Sans,sans-serif;
		max-width: 772px;
		margin: 0 auto;
		min-height: 400px;
	}
	.card-body {
		background-color: #fff;
		padding: 32px 20px 40px;
		margin-bottom: 16px;
		border-radius: 4px;
		overflow: hidden;
	}

	.h2-title {
		font-weight: bold;
		font-size: 24px;
		line-height: 30px;
		color: #404044;
		margin-bottom: 24px;
	}

	.h3-title {
		font-weight: 700;
		font-size: 16px;
		line-height: 20px;
		color: #404044;
		margin-bottom: 12px;
	}

	.height-100 {
		height: 100%;
	}

	.result-title {
		font-weight: normal;
		font-size: 32px;
		line-height: 115%;
		margin-bottom: 22px;
		font-family: "Galiver Sans", sans-serif;
	}

	.result-bottom {
		display: flex;
		margin-left: -8px;
		margin-right: -8px;
		margin-bottom: 40px;
	}

	.result-bottom-item {
		font-size: 16px;
		padding-left: 8px;
		padding-right: 8px;
		font-weight: 500;
		color: var(--black-40);
	}

	.result-bottom-item span, .result-bottom-item time {
		color: var(--black-80);
	}

	.without-results {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		margin-right: -8px;
		margin-left: -8px;
	}

	.without-results-col {
		padding-left: 8px;
		padding-right: 8px;
	}

	.without-results-left {
		padding: 32px 24px;
		background-color: var(--accent-1);
		margin-bottom: 16px;
	}

	.without-results-left-title {
		color: #fff;
		font-weight: 500;
		margin-bottom: 16px;
	}

	.without-results-left-subtitle {
		font-size: 14px;
		color: var(--black-20);
	}

	.without-results-right {
		padding: 24px;
		font-size: 14px;
		color: var(--black-80);
		border-top: 8px solid var(--background-3);
		background-color: var(--background-1);
	}

	.without-results-right-title {
		margin-bottom: 16px;
	}

	.without-results-right-link {
		text-decoration: underline;
	}

	@media (max-width: 768px) {
		.without-results {
			flex-direction: column;
		}
	}

	@media (min-width: 768px) {
		.md-w-7 {
			width: 58.333333%;
		}

		.md-w-5 {
			width: 41.666667%;
		}
	}

	/*LOADER*/
	.loader-wrapper {
		width: 100%;
		height: 100%;
		min-height: 400px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.loader-container {
		height: 60px;
		margin-bottom: 32px;
	}

	.loader-description {
		text-align: center;
		color: var(--black-60);
		font-weight: 700;
	}

	.loader,
	.loader:before,
	.loader:after {
		background: #DFDFF0;
		-webkit-animation: load1 1s infinite ease-in-out;
		animation: load1 1s infinite ease-in-out;
		width: 1em;
		height: 4em;
	}

	.loader {
		color: #DFDFF0;
		text-indent: -9999em;
		margin: 0 auto;
		font-size: 11px;
		-webkit-transform: translateZ(0);
		-ms-transform: translateZ(0);
		transform: translateZ(0);
		-webkit-animation-delay: -0.16s;
		animation-delay: -0.16s;
	}

	.loader:before,
	.loader:after {
		position: absolute;
		top: 0;
		content: '';
	}

	.loader:before {
		left: -1.5em;
		-webkit-animation-delay: -0.32s;
		animation-delay: -0.32s;
	}

	.loader:after {
		left: 1.5em;
	}

	@-webkit-keyframes load1 {
		0%,
		80%,
		100% {
			box-shadow: 0 0;
			height: 4em;
		}
		40% {
			box-shadow: 0 -2em;
			height: 5em;
		}
	}

	@keyframes load1 {
		0%,
		80%,
		100% {
			box-shadow: 0 0;
			height: 4em;
		}
		40% {
			box-shadow: 0 -2em;
			height: 5em;
		}
	}
</style>

<script>
	// import Vue from 'vue';
	import axios from 'axios';
	// import moment from 'moment';

	// Vue.prototype.moment = moment;

	import LinearChart from "./results/charts/LinearChart";
	import BipolarChart from "./results/charts/BipolarChart";
	import ResultDescription from "./results/ResultDescription";
	import Recommendations from "./results/Recommendations";

	import BannerCongratulations from "./banners/BannerCongratulations";
	import BannerGoodJob from "./banners/BannerGoodJob";
	import BannerSuits from "./banners/BannerSuits";
	import CallDescription from "./results/CallDescription";
	import Choice from "./results/Choice";
	import ResultModal from "./results/ResultModal";

	export default {
		name: 'TestResult',
		props: {
			testId: {
				type: String,
				default: '',
				require: true,
			},
			token: {
				type: String,
				default: '',
				require: true,
			}
		},
		components: {
			ResultDescription,
			BannerGoodJob,
			Recommendations,
			LinearChart,
			BipolarChart,
			BannerCongratulations,
			CallDescription,
			Choice,
			BannerSuits,
			ResultModal
		},
		data() {
			return {
				showModal: false,
				results: false,
				loaded: false,
				data: null
			}
		},

		async mounted() {
			this.loadData();
		},

		methods: {
			openModal() {
				this.showModal = !this.showModal;
			},
			update(item) {
				this.data.current_challenge = item.data.fit;
			},
			async loadData() {
				await axios.get(`https://edu-lb.proektoria.online/api/v1/tests/${this.testId}/results?token=${this.token}`).then(res => {
					this.data = res.data;

					/** Check, that response has descriptions */
					if (this.data.descriptions) {
						this.results = true;
					} else {
						setTimeout(this.loadData, 5000)
					}

					this.loaded = true;
				}, err => {
					console.log(err);
				})
			}
		}
	}
</script>
